<template>
  <v-container>
    <v-btn
      v-if="isValidToken == true"
      class="m-5"
      color="primary"
      @click="generatePdf"
      >Télécharger / Download
    </v-btn>
    <v-container
      v-if="isValidToken == true"
      id="receptHtml"
      style="max-width: 1000px"
      ref="receptHtml"
    >
      <v-row id="">
        <v-row>
          <v-col cols="2" md="2">
            <img id="img-flag" v-bind:src="flag"
          /></v-col>
          <v-col class="text-center" cols="8"><h4>Cameroun</h4> </v-col>
          <v-col cols="2" md="2">
            <img id="img-logo" v-bind:src="logo" />
          </v-col>
        </v-row>
        <v-col class="text-center" cols="12" md="12">
          <h2>Reçu d'inscription/ Registration recept</h2>
          <h4>Identité du demandeur/ Identity of applicant</h4>
        </v-col>
        <v-col cols="12">
          <v-row cols="10" justify="space-around">
            <v-col class="text-left" cols="12" md="6">
              <span class="h6_span"> Prix/Price : {{ demand.amount }} </span>
              <br />
              <span class="h6_span"> Nom/Name : {{ demand.nom }} </span> <br />
              <span class="h6_span">
                Date de naissance/Date of birth :{{ demand.birthdate }}
              </span>
              <br />
              <span class="h6_span">
                N° Titre de voyage /Passport number :
                {{ demand.passportnumber }}
              </span>
              <br />
            </v-col>

            <v-col style="" class="text-left" cols="12" md="6">
              <br />
              <span class="h6_span">
                Prénom/ Given Name : {{ demand.prenom }}
              </span>
              <br />
              <span class="h6_span">
                Lieu de naissance / Place of birth : {{ demand.birthcountry }}
              </span>
              <br />
              <span class="h6_span">
                Pré-enrôlé le/ pre-inscription :{{ demand.approuved_date }}
              </span>
              <br />
            </v-col>
          </v-row>
        </v-col>

        <v-col class="text-center" cols="12" md="12"
          ><h5>Référence de l'enregistrement</h5>
          <div id="qr-code">
            <qr-code
              :text="JSON.stringify(demand.code_demande)"
              :size="100"
            ></qr-code>
          </div>
          <br />
          <h5>{{ demand.code_demande }}</h5>

          <h5>Référence de payment/ Payment reference</h5>

          <barcode width="1" height="30" v-bind:value="demand.id_transaction">
            Show this if the rendering fails.
          </barcode>
          <br />
          <h5>Données de pré-enroulement /Pre-enrolment data</h5>
          <div class="content">
            <div class="part1">
              <qr-code
                :text="JSON.stringify(demand.code_demande)"
                :size="100"
              ></qr-code>
            </div>
            <div class="part2">
              <div class="right-div">
                <qr-code
                  :text="JSON.stringify(demand.code_demande)"
                  :size="100"
                ></qr-code>
              </div>
            </div>
            <div class="part3">
              <div class="right-div">
                <qr-code
                  :text="JSON.stringify(demand.code_demande)"
                  :size="100"
                ></qr-code>
              </div>
            </div>
            <div class="part4">
              <qr-code
                :text="JSON.stringify(demand.code_demande)"
                :size="100"
              ></qr-code>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="text-center">
          <h6 class="red-texte">Ce documment ne tient pas lieu de visa</h6>
          <h6 class="red-texte">This document does not serve as a visa</h6>
        </v-col>
      </v-row>

      <div id="movetop"></div>
    </v-container>

    <v-container v-if="isValidToken == false" fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex>
          <v-row class="text-center">
            <v-card width="500" class="mx-auto" style="border: solid 2px gray">
              <v-card-text>
                <div
                  style="
                    font-weight: 800;
                    color: red !important;
                    margin-top: 100px;
                    margin-bottom: 50px;
                  "
                >
                  <h4 style="font-weight: 800; color: red" class="mx-auto">
                    Token invalid !
                  </h4>
                </div>
                <div
                  style="
                    margin-top: 50px;
                    margin-bottom: 50px;
                    font-weight: 800;
                  "
                >
                  <v-icon color="red" size="100px"> mdi-emoticon-sad </v-icon>
                </div>
              </v-card-text>
            </v-card>
          </v-row>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import moment from "moment";
import flag from "../../public/cam_flag.png";
import logo from "../../public/flag_logo1.png";
import html2pdf from "html2pdf.js";
import VueQRCodeComponent from "vue-qrcode-component";
import { mapGetters } from "vuex";
import VueBarcode from "vue-barcode";
export default {
  name: "RegisterRecept",
  components: {
    barcode: VueBarcode,
    "qr-code": VueQRCodeComponent,
  },
  props: {},
  data() {
    return {
      token: null,
      isValidToken: null,
      demand: null,
      codeDemnde: null,
      flag: flag,
      logo: logo,
      languages: [
        { id: 0, name: "fr", flag: "fr", langue: "Français" },
        { id: 1, name: "en", flag: "us", langue: "English" },
      ],
    };
  },

  created() {
   this.token = this.$route.params.id;
    this.$store.dispatch("setCurrentRoute", this.$route.name);
    moment.locale(this.langLocal);
  },

  computed: {
    ...mapGetters(["langLocal", "isdark"]),
  },

  mounted(){
     this.initialize();
  },

  methods: {
    format_date(value, format) {
      if (value) {
        return moment(String(value)).format(format);
      }
    },

    //jspdf does not include the bootstrap style layout
    generatePdf() {
      var element = this.$refs.receptHtml;
      var opt = {
        margin: 0.1,
        filename: "RegisterRecept_" + this.codeDemnde + ".pdf",
        image: { type: "jpeg", quality: 1 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      html2pdf().from(element).set(opt).save();
    },
    changeLanguage(id) {
      this.$store.dispatch("setlanguage", this.languages[id]["name"]);
    },
    async initialize() {
      const formdata = new FormData();
      formdata.append("token", this.token);
      await this.$store
        .dispatch("getInfoTokenDemande", formdata)
        .then((response) => {
          if (response.code_demande) {
            this.codeDemnde =  response.code_demande
            let item = {
              code_demande: response.code_demande,
              id_transaction: (response.id_transaction).substring(12),
              nom: response.nom,
              birthdate: this.format_date(response.birthday, "MM/DD/YYYY"),
              prenom: response.prenom,
              birthcountry: response.birth_country,
              passportnumber: response.numpasseport,
              type_visas: response.type_visas,
              approuved_date: this.format_date(
                response.updated_at,
                "MM/DD/YYYY HH:mm:ss"
              ),
              amount: response.price + " euros ",
            };
            this.demand = item;
            this.isValidToken = true;
            this.generatePdf()
          } else {
            this.isValidToken = false;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.h6_span {
  font-weight: 400 !important;
  font-family: "Lato", Arial, sans-serif !important;
  color: #000 !important;
  font-size: 0.75em !important;
}
#receptHtml {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  border-style: solid;
  border-color: black;
  padding: 30px;
}
.light-text {
  font-size: 16px;
  font-weight: 100;
}
#site-header {
  margin-bottom: 100px;
}
#fixed-header {
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.5);
}
.no-space {
  padding: 0px !important;
  margin: 0px !important;
}
.div-lang {
  background-color: rgb(37, 51, 114);
  height: 50px;
  padding: 0px;
}

.divider {
  border-color: white !important;
}
.red-texte {
  margin: 8px;
  color: red;
  text-transform: uppercase;
  font-weight: 800;
  font-size: x-small;
}
#qr-code {
  margin: auto !important;
  width: fit-content;
}

.part1 {
  width: 50%;
  height: 50%;
  float: right;
}
.part2 {
  width: 50%;
  height: 50%;
  float: right;
}
.part3 {
  width: 50%;
  height: 50%;
  float: left;
}
.part4 {
  width: 50%;
  height: 50%;
  float: left;
}

.content {
  width: 100%;
  position: relative;
  height: 200px;
}
.right-div {
  float: right;
}
#img-logo {
  width: 120px;
  height: 80px;
  border-radius: 3px;
}
#img-flag {
  width: 120px;
  height: 80px;
  border-radius: 3px;
}
@media (max-width: 990px) {
  #img-logo {
    width: 50px;
    height: 50px;
  }
  #img-flag {
    width: 50px;
    height: 50px;
  }
}
</style>
